

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  styled,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.75),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:first-of-type': {
    paddingLeft: theme.spacing(2)
  },
  '&:last-of-type': {
    paddingRight: theme.spacing(2)
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected
  },
  '&:last-child td': {
    borderBottom: 'none'
  }
}));

const PreviousEnquiriesList = ({ open, onClose, data }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24
        }
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: theme.palette.primary.main,
          color: theme.palette.common.white,
          py: 1,
          px: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Previous Enquiries
        </Typography>
        <Button
          onClick={onClose}
          size="small"
          sx={{
            color: theme.palette.common.white,
            position: 'absolute',
            right: '2px',
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.1)'
            }
          }}
        >
          <CloseIcon />
        </Button>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            border: 'none',
            maxHeight: '60vh',
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ fontWeight: 600 }}>Enquiry No</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>Enquiry Date</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>Source</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>Enquiry By</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>Mobile No</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>EnqFor</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>Follow Name</StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 600 }}>Status</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.length > 0 ? (
                data.map((item) => (
                  <StyledTableRow key={item.EnqId} hover>
                    <StyledTableCell>{item.EnqNo}</StyledTableCell>
                    <StyledTableCell>
                      {item.EnqDt ? new Date(item.EnqDt).toLocaleDateString() : '-'}
                    </StyledTableCell>
                    <StyledTableCell>{item.SourceName || '-'}</StyledTableCell>
                    <StyledTableCell>{item.EnqBy || '-'}</StyledTableCell>
                    <StyledTableCell>{item.MobileNo || '-'}</StyledTableCell>
                    <StyledTableCell>{item.EnqFor || '-'}</StyledTableCell>
                    <StyledTableCell>{item.FlwEmpNm  || '-'}</StyledTableCell>
                    <StyledTableCell>
                      {{
                        1: 'Open',
                        5: 'Close',
                        0: 'Cancel'
                      }[item.Status] || item.Status || '-'}
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <StyledTableCell colSpan={6} align="center" sx={{ py: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                      No previous enquiries found
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      {/* <DialogActions sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
        <Button
          onClick={onClose}
          variant="outlined"
          size="small"
          sx={{
            textTransform: 'none',
            borderRadius: 1,
            px: 2
          }}
        >
          Close
        </Button>
      </DialogActions> */}
    </Dialog >
  );
};

export default PreviousEnquiriesList;